import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import ChatService from 'modules/chat/service'
import { useChatContext, INITIAL_STATE } from 'modules/chat/context'
import { useTransmissionDataContext } from 'modules/transmission/context'
import { useLeadContext } from 'modules/lead/context'
import Toast from 'common/components/toast'

let shouldDestroy = false

const useInitSparkie = () => {
  const { conversationId } = useTransmissionDataContext()
  const {
    setProfile,
    setIsLoaded,
    setHasError,
    setIsLoading,
    setConversation,
    setAdminIds
  } = useChatContext()
  const { leadData: { data: { name, email } } } = useLeadContext()
  const { t } = useTranslation()

  const initSparkie = useCallback(async () => {
    if (!conversationId || !name || !email) {
      return {}
    }

    setIsLoaded(false)
    setHasError(false)
    setIsLoading(true)

    try {
      await ChatService.configRealtimeModule({
        conversationId,
        name,
        email
      })

      shouldDestroy = true

      const profile = await ChatService.getProfile()

      await ChatService.joinConversation(conversationId)

      const conversation = await ChatService.getConversation(conversationId)

      const admins = await ChatService.getChatAdmins(conversationId)

      setConversation(conversation)
      setAdminIds(admins)
      setHasError(false)
      setProfile(profile)
      setIsLoaded(true)
    } catch (error) {
      Toast.danger(t('errorHandling.default_chat_error'))

      setHasError(true)

      console.error(error)
    } finally {
      setIsLoading(false)
    }

    return { shouldDestroy }
  }, [
    conversationId,
    name,
    email,
    setProfile,
    setIsLoaded,
    setHasError,
    t,
    setIsLoading,
    setConversation,
    setAdminIds
  ])

  const destroySparkie = useCallback(() => {
    setConversation(INITIAL_STATE.conversation)
    setAdminIds(INITIAL_STATE.adminIds)
    setProfile(INITIAL_STATE.profile)
    setIsLoaded(INITIAL_STATE.isLoaded)
    setHasError(INITIAL_STATE.hasError)

    shouldDestroy && ChatService.destroySparkie()
  }, [setConversation, setAdminIds, setProfile, setIsLoaded, setHasError])

  return { initSparkie, destroySparkie }
}

export default useInitSparkie
